import Vue from 'vue'

import Cookies from 'js-cookie'

import Element from 'element-ui'
import './assets/styles/element-variables.scss'

import '@/assets/styles/index.scss' 
import '@/assets/styles/ruoyi.scss' 
import App from './App'
import store from './store'
import router from './router'

import axios from '@/utils/request'
window.axios = axios

import permission from './directive/permission'

import './assets/icons' 
import './permission' 
import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, download, handleTree, filterForm } from "@/utils/ruoyi";
import Pagination from "@/components/Pagination";
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'
import AvueUeditor from 'avue-plugin-ueditor'

//时间插件
import moment from 'moment'//导入文件
Vue.prototype.$moment = moment//赋值使用
// 自定义表格工具扩展
import RightToolbar from "@/components/RightToolbar"
Vue.prototype.$urlHttps = 'http://192.168.7.102:7878/huz'
Vue.prototype$upUrl = 'http://192.168.7.102:7878/huz/upload'

// 全局方法挂载
// Vue.prototype.getDicts = getDicts
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree

//空值过滤器
Vue.prototype.filterForm = filterForm
Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}

Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}

// 全局组件挂载
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)



Vue.use(permission)
Vue.use(AvueUeditor)



Vue.use(Element, {
  size: Cookies.get('size') || 'medium' 
})


Vue.use(Avue,{
  size: "small",
  menuType: "text"
})

Vue.prototype.http = axios

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
